import { FolderOutlined } from "@ant-design/icons"
import { Flex, Typography } from "antd"
import React from "react"

const { Text } = Typography

interface LeadFilesFolderRowProps {
  name: string
  countLabel: string
  ariaLabel: string
  onOpen: () => void
}

function LeadFilesFolderRow({
  name,
  countLabel,
  ariaLabel,
  onOpen
}: LeadFilesFolderRowProps) {
  return (
    <Flex
      role={"button"}
      tabIndex={0}
      aria-label={ariaLabel}
      align={"center"}
      gap={8}
      className={
        "cursor-pointer rounded px-2 py-1.5 hover:bg-gray-50 focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-blue-400"
      }
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key !== "Enter") return
        e.preventDefault()
        onOpen()
      }}
    >
      <FolderOutlined className={"shrink-0 text-gray-400"} />
      <Text className={"min-w-0 flex-1"} ellipsis={{ tooltip: name }}>
        {name}
      </Text>
      <Text type={"secondary"} className={"shrink-0 text-sm"}>
        {countLabel}
      </Text>
    </Flex>
  )
}

export { LeadFilesFolderRow }
